<template>

    <b-card>

        <!--        <edit-user @refreshUserList="refreshUserList()" ref="modalEditUserC"></edit-user>-->

        <b-row>

            <!-- Currency Info: Left col -->
            <b-col
                    cols="21"
                    xl="6"
                    class="d-flex flex-column"
            >

                <!-- Currency Avatar & Action Buttons -->
                <div class="d-flex justify-content-start align-content-center">

                    <b-avatar size="104px"
                              :variant="`light-primary`"
                              rounded>
                        <coin-avatar :abv="currencyData.abv" :variant="coinVariant"></coin-avatar>
                    </b-avatar>

                    <div class="d-flex flex-column ml-1 justify-content-center">
                        <div class="mb-1">
                            <h4 class="mb-0">
                                {{ `${currencyData.name}` }}
                            </h4>
                            <span class="card-text">{{ currencyData.description }}</span>
                        </div>
                        <div class="d-flex flex-wrap">
<!--                            <b-button-->
<!--                                    @click="editUser()"-->
<!--                                    variant="primary"-->
<!--                                    size="sm"-->
<!--                            >-->
<!--                                Edit-->
<!--                            </b-button>-->
                            <!--                            <b-button  @click="deleteUser()"-->
                            <!--                                    variant="outline-danger"-->
                            <!--                                    class="ml-1"-->
                            <!--                                    size="sm"-->
                            <!--                            >-->
                            <!--                                Delete-->
                            <!--                            </b-button>-->
                        </div>
                    </div>

                </div>

<!--                &lt;!&ndash; Currency Stats &ndash;&gt;-->
<!--                <div class="d-flex align-items-center mt-2">-->

<!--                    <div class="d-flex align-items-center mr-2">-->

<!--                        <b-avatar variant="light-primary"-->
<!--                                  rounded-->
<!--                        >-->
<!--                            <feather-icon-->
<!--                                    icon="DollarSignIcon"-->
<!--                                    size="18"-->
<!--                            />-->
<!--                        </b-avatar>-->

<!--                        <div class="ml-1">-->
<!--                            <h5 class="mb-0">-->
<!--                                23.3k-->
<!--                            </h5>-->
<!--                            <small>Wallet Balance</small>-->
<!--                        </div>-->

<!--                    </div>-->

<!--                    <div class="d-flex align-items-center">-->

<!--                        <b-avatar-->
<!--                                variant="light-success"-->
<!--                                rounded-->
<!--                        >-->
<!--                            <feather-icon-->
<!--                                    icon="TrendingUpIcon"-->
<!--                                    size="18"-->
<!--                            />-->
<!--                        </b-avatar>-->

<!--                        <div class="ml-1">-->
<!--                            <h5 class="mb-0">-->
<!--                                $99.87k-->
<!--                            </h5>-->
<!--                            <small>Profits</small>-->
<!--                        </div>-->

<!--                    </div>-->

<!--                </div>-->

            </b-col>

            <!-- Right Col: Table -->
            <b-col
                    cols="12"
                    xl="6"
            >
                <table class="mt-2 mt-xl-0 w-100">

                    <tr>
                        <th class="pb-50">
                            <feather-icon
                                    icon="CheckIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.status')}}</span>
                        </th>
                        <td class="pb-50 text-nowrap">
                            {{ currencyData.status ? $t('labels.activeStatus') : $t('labels.inactiveStatus') }}
                        </td>
                    </tr>

                    <tr v-if="currencyData.name">
                        <th class="pb-50">
                            <feather-icon
                                    icon="TagIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.name')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${currencyData.name}` }}
                        </td>
                    </tr>

                    <tr v-if="currencyData.abv">
                        <th class="pb-50">
                            <feather-icon
                                    icon="TagIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.abbreviation')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${currencyData.abv}` }}
                        </td>
                    </tr>

                    <tr v-if="currencyData.symbol">
                        <th class="pb-50">
                            <feather-icon
                                    icon="UserIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.symbol')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${currencyData.symbol}` }}
                        </td>
                    </tr>

                    <tr v-if="currencyData.description">
                        <th class="pb-50">
                            <feather-icon
                                    icon="AtSignIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.description')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${currencyData.description}` }}
                        </td>
                    </tr>

                </table>
            </b-col>

        </b-row>

    </b-card>

</template>

<script>
  import { avatarText } from '@/@core/utils/filter'
  import { BAvatar, BBadge, BButton, BCard, BCol, BRow } from 'bootstrap-vue'
  // import EditUser from './EditUser'
  import { mapActions } from 'vuex'
  import CoinAvatar from './CoinAvatar'

  export default {
    name: 'CurrencyViewCurrencyInfoCard',
    components: {
      CoinAvatar,
      BCard, BButton, BRow, BCol, BAvatar, BBadge,
    },

    props: {
      currencyData: {
        type: Object,
        required: true,
      },
    },

    setup() {
      return {
        avatarText,
      }
    },

    data() {
      return {
        query: '',
        coinVariant: '',
      }
    },

    methods: {
      ...mapActions('user', ['destroy']),

      randomVariant() {
        let n = Math.random()
        if (n < 0.8)
          this.coinVariant = 'silver'
        else
          this.coinVariant = 'gold'
      },

      editUser() {
        delete this.currencyData.password
        this.$refs.modalEditUserC.showModal(this.currencyData)
      },

      async deleteUser() {
        this.$swal({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
          .then(async result => {
            if (result.value) {
              let response = await this.destroy(this.currencyData._id)
              if (response) {
                this.refreshUserList()
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: response.message,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            }
          })
      },

      refreshUserList() {
        this.$router.push({ name: 'users' })
      },

    },

    mounted() {
      this.randomVariant()
    },

  }
</script>

<style>
</style>
